// extracted by mini-css-extract-plugin
export var center = "HotspotContent-module--center--cd44d";
export var container = "HotspotContent-module--container--c2943";
export var content = "HotspotContent-module--content--92935";
export var dual = "HotspotContent-module--dual--787b2";
export var headline = "HotspotContent-module--headline--6b9ff";
export var image = "HotspotContent-module--image--d3713";
export var inner = "HotspotContent-module--inner--322f4";
export var link = "HotspotContent-module--link--d5605";
export var noLink = "HotspotContent-module--noLink--80ba0";
export var onlyText = "HotspotContent-module--onlyText--87451";
export var productGallery = "HotspotContent-module--productGallery--2c46a";
export var productGalleryContainer = "HotspotContent-module--productGalleryContainer--c9956";
export var text = "HotspotContent-module--text--be581";